import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { ChevronLeft, ChevronRight, Megaphone, X } from 'lucide-react';

export default function LoginAnnouncementsModal({ announcements, onClose }) {
  const [index, setIndex] = useState(0);
  const announcement = announcements[index];
  const multiple = announcements.length > 1;
  const move = (step) => setIndex(current => (current + step + announcements.length) % announcements.length);

  return (
    <Dialog.Root open onOpenChange={open => { if (!open) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[9000] bg-black/60" />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-[9001] flex max-h-[85vh] w-[calc(100vw-32px)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col rounded-xl border border-border bg-background p-6 text-foreground shadow-2xl"
          onKeyDown={event => {
            if (!multiple) return;
            if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
            if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
          }}
        >
          <div className="mb-5 flex items-center justify-between gap-4">
            <Dialog.Title className="flex items-center gap-2 text-xl font-semibold">
              <Megaphone className="h-5 w-5 text-primary" aria-hidden="true" />
              Announcements from Karya SaaS
            </Dialog.Title>
            <Dialog.Close asChild>
              <button type="button" aria-label="Close announcements" className="rounded-md p-2 hover:bg-muted focus-visible:outline focus-visible:outline-2">
                <X className="h-5 w-5" aria-hidden="true" />
              </button>
            </Dialog.Close>
          </div>
          <Dialog.Description className="sr-only">Announcements from Karya SaaS</Dialog.Description>
          <section aria-roledescription={multiple ? 'carousel' : undefined} aria-label="Organization announcements" className="min-h-32 overflow-y-auto break-words">
            <div aria-live="polite" aria-atomic="true">
              <h2 className="mb-3 whitespace-pre-wrap text-lg font-semibold">{announcement.announcementTitle || 'Announcement'}</h2>
              <p className="whitespace-pre-wrap text-sm leading-relaxed text-muted-foreground">{announcement.announcementDescription}</p>
              {multiple && <p className="sr-only">Announcement {index + 1} of {announcements.length}</p>}
            </div>
          </section>
          {multiple && (
            <div className="mt-5 flex items-center justify-between gap-3 border-t border-border pt-4">
              <button type="button" aria-label="Previous announcement" onClick={() => move(-1)} className="rounded-md border border-border p-2 hover:bg-muted">
                <ChevronLeft className="h-5 w-5" aria-hidden="true" />
              </button>
              <span className="text-sm text-muted-foreground">{index + 1} of {announcements.length}</span>
              <button type="button" aria-label="Next announcement" onClick={() => move(1)} className="rounded-md border border-border p-2 hover:bg-muted">
                <ChevronRight className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          )}
          <Dialog.Close asChild>
            <button type="button" className="mt-5 self-end rounded-md bg-primary px-5 py-2 text-sm font-medium text-primary-foreground hover:opacity-90">Close</button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
